export { DatePickerComponent } from './datepicker.component';
export { DatepickerModule } from './datepicker.module';
export { DayPickerComponent } from './daypicker.component';
export { MonthPickerComponent } from './monthpicker.component';
export { YearPickerComponent } from './yearpicker.component';
export { DateFormatter } from './date-formatter';
export { DatepickerConfig } from './datepicker.config';
export { BsDatepickerModule } from './bs-datepicker.module';
export { BsDatepickerDirective } from './bs-datepicker.component';
export { BsDaterangepickerDirective } from './bs-daterangepicker.component';
export { BsDatepickerConfig } from './bs-datepicker.config';
export { BsDaterangepickerConfig } from './bs-daterangepicker.config';
export { BsLocaleService } from './bs-locale.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/index.js
// module id = 529
// module chunks = 10